import { IDeregistrationContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const DeregistrationContext = createContext<IDeregistrationContextData>({} as IDeregistrationContextData);
